<div class="volunteer-application-status-log-dialog-part p-2">
	<readonly-access [readonly]="!dialogDataService.hasVolunteerEditPermissions()"></readonly-access>
	<div class="row">
		<div class="col-lg-6">
			<edit-volunteer-status-dialog-part></edit-volunteer-status-dialog-part>
		</div>
		<div class="col-lg-6 mt-3 mt-md-0">
			<div class="d-flex flex-column gap-2">
				<list-volunteer-status-logs-part></list-volunteer-status-logs-part>
				@if(isLeadVolunteer()) {
				<common-collapsible-card header="Self-reported Expertises">
					<div class="d-flex flex-column gap-2 ps-4">
						@for (expertise of expertises(); track expertise) {
						<li>
							{{expertise.name}}
							<ul class="circle-list">
								@for (topic of expertise.topics; track $index+ 1;) {
								<li>{{topic}}</li>
								}
							</ul>
						</li>
						} @empty {
						<div class="text-center">No expertises available</div>
						}
					</div>
				</common-collapsible-card>
				}
			</div>
		</div>
	</div>
</div>